// i18n.ts
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

i18n
    .use(initReactI18next)
    .init({
        resources: {
            en: {
                translation: {
                    reset_password: 'Reset Password?',
                    user_repayment_title: 'Repayment',
                    user_repayment_placeholder: "Please enter the repayment amount",
                    change_password_title: 'Change Password',
                    user_password_placeholder: "Please enter your password",
                    user_password_confirm_placeholder: "Please confirm your password",
                    user_login_title: 'Login In',
                    user_mobile_placeholder: "Please enter your mobile number",
                    create_order_store_select_title: 'Store Information',
                    create_order_user_info: 'User Information',
                    create_order_product_info: 'Product Information',
                    create_order_order_info: 'Order Information',
                    login_title: "Login Information",
                    username_placeholder: "Please enter your account",
                    password_placeholder: "Please enter your password",
                    username_required: "Account cannot be empty",
                    password_required: "Password cannot be empty",
                    submit: "Submit",
                    tab_home: 'Home',
                    tab_me: 'Me',
                    tab_calculator: 'Calculator',
                    me_username: "Test User",
                    me_about: "About Us",
                    me_my_orders: "My Orders",
                    me_my_check_user: "Check User",
                    me_logout: "Logout",
                    home_order_pending: "Pending Confirmation",
                    home_order_settled: "Settled",
                    home_order_overdue: "Overdue",
                    home_user: "User",
                    home_product: "Product",
                    home_down_payment: "Down Payment",
                    home_periods: "Periods",
                    home_submission_time: "Submission Time",
                    home_no_data: "No Data",
                    home_delete: "Delete",
                    create_order_loan_type_11: '6 months (6 installments) Interest rate 1.5（TTKH）',
                    create_order_loan_type_10: '3 months (3 installments) Interest rate 1.38（TTKH）',
                    create_order_loan_type_9: '3 months (3 installments) Interest rate 1.5',
                    create_order_loan_type_9_dark: '3 months (3 installments) Interest rate 1.5（SNZY）',
                    create_order_loan_type_12: '3 months (3 installments) Interest rate 1.4（JTKH）',
                    create_order_loan_type_13: '3 months (12 installments) Interest rate 1.4（JTKH）',
                    create_order_loan_type_8: "3 months (3 installments) Interest rate 1.6",
                    create_order_loan_1_months: "1 months (4 installments) Interest rate 1.3",
                    create_order_loan_2_months: "2 months (8 installments) Interest rate 1.4",
                    create_order_loan_3_months: "3 months (12 installments) Interest rate 1.5",
                    create_order_loan_6_months_24: "6 months (24 installments) Interest rate 1.8",
                    create_order_loan_6_months_12: "6 months (12 installments) Interest rate 1.8",
                    create_order_loan_4_months: "4 months (16 installments) Interest rate 1.6",
                    create_order_loan_5_months: "5 months (20 installments) Interest rate 1.7",
                    create_order_loan_1_months_no_rate: "1 months (4 installments)",
                    create_order_loan_2_months_no_rate: "2 months (8 installments)",
                    create_order_loan_days_8: "3 months (3 installments)",
                    create_order_loan_3_months_no_rate: "3 months (12 installments)",
                    create_order_loan_6_months_24_no_rate: "6 months (24 installments)",
                    create_order_loan_6_months_12_no_rate: "6 months (12 installments)",
                    create_order_loan_4_months_no_rate: "4 months (16 installments)",
                    create_order_loan_5_months_no_rate: "5 months (20 installments)",
                    create_order_user_name: "User Name",
                    create_order_user_mobile: "User Phone",
                    create_order_id_number: "ID Number",
                    create_order_address: "Address",
                    create_order_email: "Email",
                    create_order_staff: "Staff",
                    create_order_emergency_contact: "Emergency Contact",
                    create_order_emergency_mobile: "Emergency Contact Phone",
                    create_order_user_paymentAccount: 'Payment Account',
                    create_order_product_name: "Product Name",
                    create_order_product_serial_number: "Serial Number",
                    create_order_product_operator_lock: "Operator Lock",
                    create_order_product_memory_size: "Memory Size",
                    create_order_product_color: "Color",
                    create_order_product_imei: "IMEI",
                    create_order_product_merchant: "Merchant",
                    create_order_order_price: "Selling Price",
                    create_order_down_payment: "Down Payment",
                    create_order_contract_date: "Contract Date",
                    create_order_salesman: "SalesPerson",
                    create_order_country: "Country",
                    create_order_city: "City",
                    create_order_district: 'District',
                    create_order_order_type: "Order Type",
                    create_order_loan_days: "Loan Days",
                    create_order_store_name: "Store Name",
                    create_order_submit: "Submit",
                    create_order_required: "Please enter",
                    create_order_select: 'Please Select',
                    create_order_select_date: 'Please Select Date',
                    create_order_title: "Create Order",
                    order_details_title: "Order Details",
                    order_details_user_name: "User Name",
                    order_details_user_mobile: "User Phone",
                    order_details_id_number: "ID Number",
                    order_details_address: "Address",
                    order_details_age: "Age",
                    order_details_emergency_contact: "Emergency Contact",
                    order_details_emergency_mobile: "Emergency Contact Phone",
                    order_details_product_name: "Product Name",
                    order_details_product_serial_number: "Apple ID",
                    order_details_product_memory_size: "Memory Size",
                    order_details_product_color: "Color",
                    order_details_product_imei: "IMEI",
                    order_details_product_merchant: "Merchant",
                    order_details_order_price: "Selling Price",
                    order_details_down_payment: "Down Payment",
                    order_details_contract_date: "Contract Date",
                    order_details_order_type: "Order Type",
                    order_details_loan_periods: "Loan Periods",
                    order_details_single_period_days: "Single Period Days",
                    calculator_title: 'Calculator',
                    calculator_btn_submit: 'Calculator',
                    calculator_reset: 'Reset',
                    order_repayment_date: 'Repayment Date',
                    loan_principal: 'Principal',
                    loan_fees: 'Fees',
                    loan_repayment_amount: 'Repayment Amount',
                    calculator_monthly_supply: 'Installment Amount',
                    approval_not_pass: 'Approval Not Pass',
                    common_remarks: 'Remarks',
                    common_status: 'Status',
                    common_modify: 'Modify',
                    common_ordere_no: 'OrderNo',
                    hubtel_direct_debit_channel: 'Available Channels',
                    common_application_time: 'Application Time',
                    check_user_title: 'User Check',
                    store_select_title: 'Select A Store',
                    repayment_plan: 'Repayment Plan',
                    azampay_login_title: 'AzamPay Login',
                    azampay_orders_title: 'My Orders',
                    azampay_pay_title: 'AzamPay Payment',
                    azampay_select_provider: 'Please select a provider',
                    azampay_enter_phone: 'Please enter your phone number',
                    azampay_enter_amount: 'Please enter the amount',
                    azampay_confirm_payment: 'Confirm Payment',
                    azampay_processing: 'Processing...',
                    azampay_payment_initiated: 'Payment initiated successfully!',
                    azampay_payment_failed: 'Payment failed',
                }
            },
            zh: {
                translation: {
                    reset_password: '忘记密码?',
                    user_repayment_title: '还款',
                    user_repayment_placeholder: "请输入还款金额",
                    change_password_title: '修改密码',
                    user_password_placeholder: "请输入密码",
                    user_password_confirm_placeholder: "请确认密码",
                    user_login_title: '登录',
                    user_mobile_placeholder: "请输入手机号",
                    create_order_store_select_title: '商户信息',
                    create_order_user_info: '用户信息',
                    create_order_product_info: '产品信息',
                    create_order_order_info: '订单信息',
                    login_title: "登陆信息",
                    username_placeholder: "请输入账号",
                    password_placeholder: "请输入密码",
                    username_required: "账号不能为空",
                    password_required: "密码不能为空",
                    submit: "提交",
                    tab_home: '首页',
                    tab_me: '我的',
                    tab_calculator: '贷款计算器',
                    me_username: "测试用户",
                    me_about: "关于我们",
                    me_my_orders: "我的订单",
                    me_my_check_user: "用户校验",
                    me_logout: "退出登录",
                    home_order_pending: "状态：待确定",
                    home_order_settled: "状态：结清",
                    home_order_overdue: "状态：逾期",
                    home_user: "用户",
                    home_product: "产品",
                    home_down_payment: "首付款",
                    home_periods: "期数",
                    home_submission_time: "提交时间",
                    home_no_data: "没有数据",
                    home_delete: "删除",
                    create_order_loan_type_11: '6个月(6期，每月还) 利率1.5（TTKH）',
                    create_order_loan_type_10: '3个月(3期，每月还) 利率1.38（TTKH）',
                    create_order_loan_type_9: '3个月(3期，每月还) 利率1.5',
                    create_order_loan_type_9_dark: '3个月(3期，每月还) 利率1.5（SNZY）',
                    create_order_loan_type_12: '3个月(3期，每月还) 利率1.4（JTKH）',
                    create_order_loan_type_13: '3个月(12期，每周还) 利率1.4（JTKH）',
                    create_order_loan_type_8: "3个月(3期，每月还) 利率1.6",
                    create_order_loan_1_months: "1个月(4期，每周还) 利率1.3",
                    create_order_loan_2_months: "2个月(8期，每周还) 利率1.4",
                    create_order_loan_3_months: "3个月(12期，每周还) 利率1.5",
                    create_order_loan_6_months_24: "6个月(24期，每周还) 利率1.8",
                    create_order_loan_6_months_12: "6个月(12期，两周还) 利率1.8",
                    create_order_loan_4_months: "4个月(16期，每周还) 利率1.6",
                    create_order_loan_5_months: "5个月(20期，每周还) 利率1.7",
                    create_order_loan_1_months_no_rate: "1个月(4期，每周还)",
                    create_order_loan_2_months_no_rate: "2个月(8期，每周还)",
                    create_order_loan_days_8: "3个月(3期，每月还)",
                    create_order_loan_3_months_no_rate: "3个月(12期，每周还)",
                    create_order_loan_6_months_24_no_rate: "6个月(24期，每周还)",
                    create_order_loan_6_months_12_no_rate: "6个月(12期，两周还)",
                    create_order_loan_4_months_no_rate: "4个月(16期，每周还)",
                    create_order_loan_5_months_no_rate: "5个月(20期，每周还)",
                    create_order_user_name: "用户名称",
                    create_order_user_mobile: "用户电话",
                    create_order_id_number: "身份证",
                    create_order_address: "地址",
                    create_order_email: "邮箱",
                    create_order_staff: "职位",
                    create_order_emergency_contact: "紧急联系人",
                    create_order_emergency_mobile: "紧急联系人电话",
                    create_order_user_paymentAccount: '收款账号',
                    create_order_product_name: "产品名",
                    create_order_product_serial_number: "序列号",
                    create_order_product_operator_lock: "运营商锁",
                    create_order_product_memory_size: "内存",
                    create_order_product_color: "颜色",
                    create_order_product_imei: "IMEI",
                    create_order_product_merchant: "商户",
                    create_order_order_price: "售价",
                    create_order_down_payment: "首付",
                    create_order_contract_date: "签约日期",
                    create_order_salesman: "业务员",
                    create_order_country: "国家",
                    create_order_city: "城市",
                    create_order_district: '区域',
                    create_order_order_type: "订单类型",
                    create_order_loan_days: "借款天数",
                    create_order_store_name: "商户名称",
                    create_order_submit: "提交",
                    create_order_required: "请输入",
                    create_order_select: '请选择',
                    create_order_select_date: '请选择日期',
                    create_order_title: "创建订单",
                    order_details_title: "订单详情",
                    order_details_user_name: "用户名称",
                    order_details_user_mobile: "用户电话",
                    order_details_id_number: "身份证",
                    order_details_address: "地址",
                    order_details_age: "年龄",
                    order_details_emergency_contact: "紧急联系人",
                    order_details_emergency_mobile: "紧急联系人电话",
                    order_details_product_name: "产品名",
                    order_details_product_serial_number: "苹果ID",
                    order_details_product_memory_size: "内存",
                    order_details_product_color: "颜色",
                    order_details_product_imei: "IMEI",
                    order_details_product_merchant: "商户",
                    order_details_order_price: "售价",
                    order_details_down_payment: "首付",
                    order_details_contract_date: "签约日期",
                    order_details_order_type: "订单类型",
                    order_details_loan_periods: "借款期数",
                    order_details_single_period_days: "单期天数",
                    calculator_title: '计算器',
                    calculator_btn_submit: '计算',
                    calculator_reset: '重置',
                    order_repayment_date: '还款日',
                    loan_principal: '本金',
                    loan_fees: '利息',
                    loan_repayment_amount: '还款金额',
                    calculator_monthly_supply: '月供',
                    approval_not_pass: '审核不通过',
                    common_remarks: '备注',
                    common_status: '状态',
                    common_modify: '重新编辑',
                    common_ordere_no: '订单号',
                    hubtel_direct_debit_channel: '可用渠道',
                    common_application_time: '申请时间',
                    check_user_title: '校验用户',
                    store_select_title: '选择店铺',
                    repayment_plan: '还款计划',
                    azampay_login_title: 'AzamPay 登录',
                    azampay_orders_title: '我的订单',
                    azampay_pay_title: 'AzamPay 支付',
                    azampay_select_provider: '请选择运营商',
                    azampay_enter_phone: '请输入手机号',
                    azampay_enter_amount: '请输入金额',
                    azampay_confirm_payment: '确认支付',
                    azampay_processing: '处理中...',
                    azampay_payment_initiated: '支付发起成功！',
                    azampay_payment_failed: '支付失败',
                }
            }
        },
        lng: "en", // 默认语言
        fallbackLng: "en",
        interpolation: {
            escapeValue: false // 不需要转义
        }
    }).then(r => {});

export default i18n;
